// IntercomArticleModal.js
'use strict';
import { connect } from 'react-redux';
import fetchFaqArticleDetail from '../action/fetchFaqArticleDetail.js';
import toggleModal from '../action/toggleModal.js';
import getIntercomArticleData from '../selector/getIntercomArticleData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getOperationData from '../selector/getOperationData.js';
import { getCurrentFaqLanguage } from '../resource/getCurrentLanguage.js';

import { FAQ_SUPPORTED_LANGUAGES } from '../RemoteConfigKeys.js';
import IntercomArticleModal from '../component/IntercomArticleModal.jsx';
import { withTranslation } from 'react-i18next';

const mapStateToProps = (state, { i18n }) => {
  const faqSupportedLanguages = getRemoteConfigData(
    state,
    FAQ_SUPPORTED_LANGUAGES
  );
  const language = getCurrentFaqLanguage({
    i18n,
    supportedLanguages: faqSupportedLanguages,
  });

  const articleId = getOperationData(
    state,
    ['modal', 'IntercomArticleModal'],
    'articleId'
  );
  const articleConfigKey = getOperationData(
    state,
    ['modal', 'IntercomArticleModal'],
    'articleConfigKey'
  );
  return {
    language,
    articleId,
    articleConfigKey,
    title: getIntercomArticleData(state, [articleId, language], 'title'),
    body: getIntercomArticleData(state, [articleId, language], 'body'),
    updatedAtUnix: getIntercomArticleData(
      state,
      [articleId, language],
      'updated_at'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleModal: data => dispatch(toggleModal(data)),
    fetchFaqArticleDetail: ({ id, language, httpProxyHeaders }) =>
      dispatch(fetchFaqArticleDetail({ id, language, httpProxyHeaders })),
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(IntercomArticleModal)
);
